module.exports = __webpack_public_path__ + "book-2ce4abf846171e257a8a09fa1cf01ffb.png";